export interface APIResponse {
    ResponseType: string
    StatusMsg: string
    data: any
    success: boolean
}

export const APIStatus  = {
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    DATA_NOT_FOUND: 'DATA_NOT_FOUND'
}

export enum APIEnv {
    NODE_BOOKSTORE,
    LEARNING,
    REDIS,
    NODE_DASHBOARD,
    ENDMILE,
    MARKETING,
    DOT_NET,
    NODE_DASHBOARD_SESSION_MANAGEMENT
}